<template>
  <div>
    <!-- <div class="tabs is-marginless-bottom has-bg-light">
      <ul class="has-text-weight-medium">
        <li :class="{'is-active' : tab === 'sale'}" v-if="sales && sales.length">
          <a @click="selectTab('sale')">En cours</a>
        </li>
        <li :class="{'is-active' : tab === 'proposal'}" v-if="proposals && proposals.length">
          <a @click="selectTab('proposal')">Historique</a>
        </li>
      </ul>
    </div> -->
    <div class="columns is-vcentered is-gapless is-padding-right is-border-bottom has-bg-light">
      <div class="column">
        <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns">
          <a
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
            @click="selectTab('reserved')" :class="{'is-active': tab === 'reserved'}"
          >Réservations ({{reservedSales.length}})</a>
          <a
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
            @click="selectTab('acted')" :class="{'is-active': tab === 'acted'}"
          >Actes ({{actedSales.length}})</a>
          <a
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
            @click="selectTab('canceled')" :class="{'is-active': tab === 'canceled'}"
          >Annulations ({{canceledSales.length}})</a>
        </div>
      </div>
    </div>
    <table class="table is-hoverable is-fullwidth is-marginless-bottom">
      <thead>
      <tr class="is-size-6">
        <th>
          <span v-if="tab === 'reserved'">Date de réservation</span>
          <span v-else-if="tab === 'acted'">Date d'acte</span>
          <span v-else-if="tab === 'canceled'">Date d'annulation</span>
        </th>
        <th><span>Ref ADV</span></th>
        <th><span>Programme</span></th>
        <th><span>Référence du Lot</span></th>
        <th v-if="isAdmin && isDistributeurMode"><span>Promoteur</span></th>
        <th><span>Collaborateur</span></th>
        <th><span>Statut</span></th>
      </tr>
      </thead>
      <tbody class="is-size-5 has-text-text">
      <tr v-for="s in currentSales" :key="s.pk" class="is-size-6" v-if="currentSales && currentSales.length">
        <td>
          <span v-if="tab === 'reserved'">
            <span v-if="s.signature_date">{{s.signature_date|prettyDate}}</span>
            <span v-else>N.C</span>
          </span>
          <span v-else-if="tab === 'acted'">{{s.sale_date|prettyDate}}</span>
          <span v-else-if="tab === 'canceled'">{{s.cancel_date|prettyDate}}</span>
        </td>
        <td>
          <router-link :to="{name: 'AdvInfos', params: {id: s.pk}}">
            <span>{{s.ref}}</span>
          </router-link>
        </td>
        <td>
          <router-link :to="{name: 'ProgramVue', params: {id: s.program}}">
            <span>{{s.program_name}}</span>
          </router-link>
        </td>
        <td>
          <router-link :to="{name: 'LotVue', params: {id: s.lot}}">
            <span>{{s.lot_ref}}</span>
          </router-link>
        </td>
        <td v-if="isAdmin && isDistributeurMode">
          <span>{{s.promoteur_name}}</span>
        </td>
        <td>
          <router-link :to="{name: 'UserVue', params: {id: s.seller}}">
            <span>{{s.seller_name|smallName}}</span>
          </router-link>
        </td>
        <td>
          <span>{{s.status|statusLabel}}</span>
        </td>
      </tr>
      <tr v-if="!currentSales.length">
        <br>
        <span v-if="tab === 'reserved'" class="is-padding">Aucune réservation</span>
        <span v-else-if="tab === 'acted'" class="is-padding">Aucun acte</span>
        <span v-else-if="tab === 'canceled'" class="is-padding">Aucune annulation</span>
        <br>
        <br>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { DefaultValues } from '@/mixins'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ContactSalesList',
    data () {
      return {
        tab: 'reserved'
      }
    },
    mixins: [DefaultValues],
    props: {
      sourceSales: {
        type: Array,
        required: true
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isDistributeurMode']),
      currentSales () {
        if (this.tab === 'reserved') {
          return this.reservedSales
        } else if (this.tab === 'acted') {
          return this.actedSales
        } else {
          return this.canceledSales
        }
      },
      reservedSales () {
        let okStatus = ['reserved']
        return this.sourceSales.filter(x => {
          return okStatus.includes(x.status)
        })
      },
      canceledSales () {
        let okStatus = ['canceled_by_admin', 'canceled_by_seller']
        return this.sourceSales.filter(x => {
          return okStatus.includes(x.status)
        })
      },
      actedSales () {
        let okStatus = ['sold']
        return this.sourceSales.filter(x => {
          return okStatus.includes(x.status)
        })
      }
    },
    methods: {
      selectTab (value) {
        this.tab = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactRightPanel/ContactSalesList.vue